import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  error: {
    id: 'commerce.credit-card-base.error-message.error',
    defaultMessage: 'We are not able to use this credit card {br} Try again or use another one.',
    description: 'Generic error section message shown below the credit card form'
  }
});